import { createFileRoute } from "@tanstack/react-router"

import { MagicLinkPage } from "@/pages/(guest)/magic-link/page"

export const Route = createFileRoute("/_guest/magic-link")({
  component: MagicLinkPage,
})
